import api from '../api';

const path = '/sell/bike';
const pathPro = '/sell/pro/bike';

export const addBikeRequest = (values) => api.post(`${path}/add`, values);
export const deleteBikeRequest = (id) => api.delete(`${path}/delete/${id}`);
export const getBikeRequest = (id) => api.get(`${path}/get/${id}`);
export const getBikeListRequest = (params) =>
    api.get(`${path}/get`, { params });
export const editBikeRequest = (updates) =>
    api.put(`${path}/edit/${updates.id}`, {
        updates,
    });
export const updateBikeRequest = (updates) =>
    api.put(`${path}/update/${updates.id}`, updates);

export const addBikeProRequest = (values) => api.post(`${pathPro}/add`, values);
export const editBikeProRequest = (updates) =>
    api.put(`${pathPro}/edit/${updates.id}`, {
        updates,
    });
